<template>
  <el-dialog
    :title="$t('syncWechatCommunity.title')"
    :visible.sync="visible"
    width="30%"
    @close="closeSyncWechatCommunityModel"
  >
    <div style="text-align: center">
      <p>{{ $t('syncWechatCommunity.confirmText') }}</p>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeSyncWechatCommunityModel">{{ $t('syncWechatCommunity.cancel') }}</el-button>
      <el-button type="primary" @click="confirmSyncWechatCommunity">{{ $t('syncWechatCommunity.confirm') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { syncWechatCommunity } from '@/api/community/communityManageApi'

export default {
  name: 'SyncWechatCommunity',
  data() {
    return {
      visible: false,
      syncWechatCommunityInfo: {}
    }
  },

  methods: {
    openModal(params) {
      this.syncWechatCommunityInfo = params
      this.visible = true
    },
    confirmSyncWechatCommunity() {
      syncWechatCommunity(this.syncWechatCommunityInfo).then(res => {
        console.log(res)
        this.$message.success(this.$t('syncWechatCommunity.syncSuccess'))
        this.visible = false
        this.$emit('listData')
      }).catch(error => {
        this.$message.error(error.message)
      })
    },
    closeSyncWechatCommunityModel() {
      this.visible = false
    }
  }
}
</script>